module.exports = __webpack_public_path__ + "img/vertical_4_6_9005.0b23f7f6.png";